import { Image, Avatar, Badge, Box, Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Textarea, useDisclosure } from "@chakra-ui/react";
import Link from "next/link";
import { useState } from "react";
import { useAuth } from "../../utils/auth/newAuth";
import { clientAnalytics } from "../../utils/utilties";
import { AuthModal } from "../Auth/withAuthModal";
import { TextArea } from "../Inbox";
import { CheckIcon } from "@chakra-ui/icons";
import { AboutRow, CardAnchor, LocationRow, NameInfo, NameRow, AgentOuterShell, ResponseTime, RowInfo, StatCircle, StatFlex, StatHolder } from './AgentCardStyles'
interface recipient {
    uid: string;
    fullName: string
}
interface AgentProps {
    fullName: string;
    about: string;
    brokeragePhoto: string;
    location: string;
    pro: boolean;
    photoURL: string;
    slug: string;
    uid: string;
    title: string;
    soldListings?: number;
    availableListings?: number;
    avgResponseTimeInDays?: number;
    onOpen(): void;
    setMessageToSend(t: boolean): ()=> void;
    setCurrentRecipient: ({ }) => void;
    messageSent: boolean;
    // Include active listing and sold listing count
}


interface TriggerAuthProps {
    hook: string;
    header: string;
    signUpMethod?: "email" | "verify";
    userEmail?: string;
    authModalEmailType?: "existing";
}
const AgentCard = (props: AgentProps) => {
    const {
        fullName,
        about,
        brokeragePhoto,
        location,
        pro,
        uid,
        photoURL,
        messageSent,
        slug,
        title,
        soldListings,
        availableListings,
        avgResponseTimeInDays,
        onOpen,
        setMessageToSend,
        setCurrentRecipient

    } = props;
    const [authHeader, setAuthHeader] = useState(null);
    const [isAuthBoxOpen, setIsAuthBoxOpen] = useState(null);


    const triggerAuth = ({
        hook,
        header,
        signUpMethod,
        userEmail,
        authModalEmailType,
    }: TriggerAuthProps) => {
        // Mixpanel.track(hook, { "Listing": id });

        clientAnalytics.track("Sign up attempted", {
            hook,
        });

        setAuthHeader(header);
        setIsAuthBoxOpen(true);
    };
    const { profile, userId } = useAuth();
    const messageHandler = () => {
        setCurrentRecipient({
            uid,
            fullName,
            pro,
            photoURL,
            title
        });
        if (profile) {
            onOpen();
        }
        else {
            setMessageToSend(true);
            triggerAuth({
                hook: "Message agent",
                header: `Log in or sign up to message ${fullName.split(' ')[0]}`,
            })
        }
    }
    return (<>
        <AgentOuterShell>
            <Link href={`/profile/${slug}`}>
                <CardAnchor target="_blank">
                    <RowInfo>
                        <Avatar
                            size="lg"
                            src={photoURL}
                        />

                        <NameInfo>
                            <NameRow>
                                {fullName}
                                {pro &&
                                    <Badge
                                        marginLeft="8px"
                                        borderRadius="10px"
                                        paddingX="6px"
                                        colorScheme={"green"}
                                        variant="solid"
                                    // variant="subtle"                                
                                    >
                                        PRO
                                    </Badge>
                                }
                            </NameRow>
                            <LocationRow>
                                {location}
                            </LocationRow>
                        </NameInfo>

                    </RowInfo>
                    {about &&
                        <AboutRow>
                            {about}...
                        </AboutRow>}

                    {(availableListings > 0 || soldListings > 0) &&
                        <Flex
                            width={"100%"}
                            justifyContent={'space-between'}
                            alignItems="center"
                        >
                            <StatFlex>
                                {availableListings > 0 ?
                                    <StatHolder>
                                        <StatCircle>{availableListings}</StatCircle> <p style={{width: "100px"}}>Listing{availableListings > 1 && "s"} Available</p>
                                    </StatHolder> : null
                                }

                                {soldListings > 0 ?
                                    <StatHolder>
                                        <StatCircle>{soldListings}</StatCircle> Sold
                                    </StatHolder> : null
                                }
                            </StatFlex>
                            {brokeragePhoto &&
                                <Box
                                    width="80px"
                                    height={"35px"}
                                    position={"relative"}
                                    marginTop={{ base: "20px", md: "0px" }}
                                    marginBottom={{ base: "20px", md: "0px" }}
                                >
                                    <Image src={brokeragePhoto} 
                                        objectFit="contain"
                                    max-width="100%" height="100%" />
                                </Box>
                            }
                        </Flex>
                    }
                </CardAnchor>
            </Link>

            <div>
                <ResponseTime>
                    {avgResponseTimeInDays !== null &&
                        <>
                            {avgResponseTimeInDays < 1 &&
                                <Image
                                    src="/images/quickResponse.svg"
                                    width={"15px"}
                                    height={"15px"}
                                />
                            }
                            Typically responds in {avgResponseTimeInDays < 1 ? "under a day" : `${avgResponseTimeInDays} day${avgResponseTimeInDays > 1 ? "s" : ""}`}
                        </>
                    }
                </ResponseTime>

                <Button
                    width="100%"
                    isDisabled={messageSent || userId === uid}
                    variant={"outline"}
                    colorScheme="green"
                    leftIcon={messageSent ? <CheckIcon /> : null}
                    borderRadius="20px"
                    padding="12px 0px"
                    onClick={messageHandler}
                >
                    Message{messageSent ? "d" : ""}
                </Button>
            </div>

        </AgentOuterShell>
        <AuthModal
            header={authHeader}
            onClose={() => { setIsAuthBoxOpen(false) }}
            isOpen={isAuthBoxOpen}
        />
    </>);
}

export default AgentCard;